module.exports = __webpack_public_path__ + "img/portfolio-guide-modal-illustration-fr3.796f309.png";